<div class="mat-elevation-z2 control-strip" style="display: flex; align-items: stretch; padding-bottom: 0;">
    <div style="display: inline-block; padding-top:5px; flex: 1;">
     <div>
        <button mat-button class="command-button" style="scale: 95%"
                *ngIf="editResponsesMyAgency || editMasterResponses"
                [disabled] = "isEditing || (_serviceRequest?.recordStatus === 0) || (_caseRecord?.caseStatus !== null
                 && _caseRecord?.caseStatus !== 'Open') "
                (click)="editRecord()" matTooltip="Edit responses to questions"
                mat-button>
            <mat-icon>edit</mat-icon>
            Edit
        </button>
      </div>
    </div>
        <div style="display: inline-block; width: 50%; padding-top:10px;">
        <mat-checkbox *ngIf="enableQuestionsFromPreviousAgencies" style="margin-left:10px;"
          labelPosition="after"
          binary="true" [(ngModel)]="showHistoricQuestions"> Show questions from previous agencies</mat-checkbox>
    </div>
    <div *ngIf="_calledFrom === 'requests' && _serviceRequest?.clericalOpen === 1"
         style="display: inline-flex;
                align-items: center;
                background-color: #2dde5e;
                color: black;
                padding: 5px 16px;
                border-radius: 0;
                font-weight: bold;
                font-size: 12px;
                height: 38px;
                box-sizing: border-box;"
         matTooltip="Note: you are editing a record for this request only - it will not be reflected in other related requests and cases"
         matTooltipPosition="below">
        <mat-icon style="font-size: 15px; height: 15px; width: 15px; margin-right: 6px; line-height: 15px;">history_edu</mat-icon>
        History Edit Mode
    </div>
</div>

<div style="padding: 20px; height: 475px;width:100%; display: flow;overflow: auto;" >
    <div style="display:inline-block; width:100%">
        <span style="font-size:10pt; font-weight: bold;padding-right: 5px;">Master Questions: </span>
		  <span *ngIf="editResponsesMyAgency && !editMasterResponses" style="color: blue">
		    [Only service qualifications can be edited here]
		  </span>
		  <span *ngIf="!editResponsesMyAgency && editMasterResponses" style="color: blue">
		    [Only master qualifications can be edited]
		  </span>
    </div>

  <table style="width:100%;" border="0">

  <tr *ngFor="let item of qualificationsList;let i = index" style="width:100%;height: 40px; ">
      <td style="font-weight: 500; width:30px;">{{i+1}}.</td>
    <td class="question-col" style="width: 750px;padding-left: 5px;">
      <label>{{ item.question }}</label>
    </td>

    <td class="question-col" style="padding-left: 33px;">
      <span  *ngIf="item.required === 1" style="min-width: 13px;display: inline-table;">
      	<label class="required"
               *ngIf="((this._calledFrom === 'requests') && (!item.masterFlag))">*</label>

        <!-- <label class="required" *ngIf="((!readOnlyFlag) && (item.masterFlag))">*</label> -->
      </span>

        <!-- item is not required -->
      <span  *ngIf="item.required === 0" style="min-width: 13px;display: inline-table;">
      	<label class="required" > </label>
      </span>
        <!-- CUSTOM QUALIFICATIONS TEXT ANSWERS -->
          <input *ngIf="item.controlType==='Text'" type="text"
                 style="width:280px"
                 ngDefaultControl
                 [(ngModel)]="item.value"
                 [disabled]="!isEditing || !editResponsesMyAgency" />
      <!-- <input *ngIf="item.controlType === 'Number'" matInput type="number" step="1" [(ngModel)]="item.value" [disabled]="!isEditing" style="width: 50px;"> -->

        <!-- CUSTOM QUALIFICATIONS NUMERICAL ANSWERS -->
       <p-inputNumber *ngIf="item.controlType === 'Number'" [(ngModel)]="item.value" [showButtons]="true"
                     [inputStyle]="{'width': '100px'}"
                      ngDefaultControl
                     inputId="stacked"[(ngModel)]="item.value" [disabled]="!isEditing || !editResponsesMyAgency" > </p-inputNumber>

        <!-- MASTER QUALIFICATION RESPONSES - YES/NO/DOES NOT APPLY -->
        <dw-dropdown *ngIf="item.masterFlag === true"
                     ngDefaultControl
                     [disabled]="!isEditing || !editMasterResponses"
                     [useStatusOptions]="'ynd'"
                     [selectedItem]="item.value"
                     [(ngModel)]="item.value"
                     [controlWidth]="'130px'"
                     (itemSelected)="item.value = $event;">
        </dw-dropdown>

        <!-- CUSTOM QUALIFICATION RESPONSES - YES/NO/DOES NOT APPLY -->
        <dw-dropdown *ngIf="(item.controlType==='YND') && (!item.masterFlag)"
                     [disabled]="!isEditing || !editResponsesMyAgency"
                     ngDefaultControl
                     [useStatusOptions]="'ynd'"
                     [selectedItem]="item.value"
                     [(ngModel)]="item.value"
                     [controlWidth]="'130px'"
                     (itemSelected)="item.value = $event;">
        </dw-dropdown>

        <!-- CUSTOM QUALIFICATIONS - DATE ANSWERS -->
        <span *ngIf="item.controlType==='Date'" style="margin-left: -3px;">
          <dw-calendar
            [disabled]="!isEditing || !editResponsesMyAgency" [(ngModel)]="item.value"
            ngDefaultControl
            [ngStyle]="{ 'width.px': 181, 'display': 'inline-table' }">
          </dw-calendar>
        </span>

        <span style="margin-left: 10px;vertical-align: inherit;">
              	<mat-icon [matTooltip]="item.description" matTooltipPosition="right">help</mat-icon>
        </span>
    </td>
  </tr>

</table>
<!-- HISTORICAL QUESTIONS -->
<div *ngIf="showHistoricQuestions && historicalResponses.length > 0">
  <h3>Historical questions:</h3>
  <table>
      <tr *ngFor="let item of historicalResponses;let i = index" style="width:100%;height: 40px; ">
          <td style="font-weight: 500; width:30px">{{i+1}}.</td>
          <td class="history-col" style="width: 750px;padding-left: 5px;">
              <label>{{ item.questionText }}</label>
          </td>

          <td class="question-col">
              <span style="min-width: 13px;display: inline-table;">
      	        <label class="required" *ngIf="item.required===1">*</label>
                </span>

             <label [disabled]="true" style="font-weight: 500;">{{item.response}}</label>
              <span style="margin-left: 10px;vertical-align: inherit;">
              	<mat-icon [matTooltip]="item.description" matTooltipPosition="right">help</mat-icon>
              </span>
          </td>
</table>
</div>

<!----------------------->
	<!-- ERROR LINE --------->
	<!----------------------->
	<div class="error-line" [hidden]='!strErr.length'
		 style="text-align:left">{{strErr}}</div>
	<!----------------------->
	<!-- SAVE STRIP        -->
	<!----------------------->
	<div class="save-close-strip" style="bottom: 3px;" *ngIf="isEditing">

		<button mat-button class="command-button"
				(click)="submitRecord()" matTooltip="Save the record"
				mat-button>
			<mat-icon>check_circle_outline</mat-icon>
			Submit
		</button>
		<button mat-button class="command-button"
				(click)="cancelSubmitRecord()" matTooltip="Cancel edits" mat-button>
			<mat-icon>highlight_off</mat-icon>
			Cancel
		</button>
	</div>
</div>
